import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Konum from "../../../components/List/KonumList.jsx";

const AdminKonum = () => {
    return (
        <div className="dashboard">
            <Sidebar />
            <div className="dashboardContainer">
                <Navbar />
                <div className="listContainer">
                    <Konum title={"Konum"} />
                </div>
            </div>
        </div>
    )
}

export default AdminKonum
